// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-verification-popup {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 113vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .popup-content {
    background-color: white;
    border-radius: 12px;
    padding: 30px;
    text-align: center;
    width: 460px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }
  
  .popup-image {
    width: 299px;
  }
  
  .popup-title {
    font-size: 24px;
    color: #052456;
    font-weight: 600;
    /* margin-bottom: 10px; */
  }
  
  .popup-description {
    font-size: 14px;
    font-weight: 400;
    color: #161F33;
    margin-bottom: 15px;
    margin-top: 20px;
  }
  
  .popup-phone-number {
    font-size: 18px;
    font-weight: 700;
    color: #161F33;
    margin-bottom: 20px;
  }
  
  .request-otp-btn {
    background-color: #F15E22;
    color: #ffffff;
    border: none;
    border-radius: 40px;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    height: 52px;
    transition: background-color 0.3s;
  }
  
  .request-otp-btn:hover {
    background-color: #e65a00;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/otpVerificationPopup/otpVerificationPopup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".otp-verification-popup {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 113vh;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n  }\n  \n  .popup-content {\n    background-color: white;\n    border-radius: 12px;\n    padding: 30px;\n    text-align: center;\n    width: 460px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .popup-image {\n    width: 299px;\n  }\n  \n  .popup-title {\n    font-size: 24px;\n    color: #052456;\n    font-weight: 600;\n    /* margin-bottom: 10px; */\n  }\n  \n  .popup-description {\n    font-size: 14px;\n    font-weight: 400;\n    color: #161F33;\n    margin-bottom: 15px;\n    margin-top: 20px;\n  }\n  \n  .popup-phone-number {\n    font-size: 18px;\n    font-weight: 700;\n    color: #161F33;\n    margin-bottom: 20px;\n  }\n  \n  .request-otp-btn {\n    background-color: #F15E22;\n    color: #ffffff;\n    border: none;\n    border-radius: 40px;\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: 700;\n    cursor: pointer;\n    width: 100%;\n    height: 52px;\n    transition: background-color 0.3s;\n  }\n  \n  .request-otp-btn:hover {\n    background-color: #e65a00;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
